// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__h93xF","footer":"NavbarSimple_footer__0+l39","link":"NavbarSimple_link__kOWuB","linkIcon":"NavbarSimple_linkIcon__3L2A9"};